import { useEffect, useState, forwardRef, useImperativeHandle } from 'react';
import './UploadDocument.css';
import csv_img from "../../assets/images/csv-file.png";
import file_img_storage from "../../assets/images/file-storage.png";
import png_svg from "../../assets/images/png-svg.svg";
import jpg_svg from "../../assets/images/jpg-svg.svg";
import doc_svg from "../../assets/images/doc-svg.svg";
import pdf_svg from "../../assets/images/pdf-svg.svg";
import txt_svg from "../../assets/images/txt-svg.svg";
import xls_svg from "../../assets/images/xls-svg.svg";
import svg_svg from "../../assets/images/svg-svg.svg";
import { toast } from 'react-toastify';
import { Tooltip } from 'react-tooltip';
import cancel from "../../assets/images/cancel.svg"
import FilePreviewModal from './FilePreviewModal';
import { useAuth } from '../../features/auth/AuthContext';
import api from '../../api/api';
import { error } from 'jquery';
import { useSelector } from 'react-redux';
// import * as pdfjsLib from 'pdfjs-dist';
import VoiceAudioRecorder from './VoiceAudioRecorder';
import VoiceMicButton from './VoiceMicButton';
import headphones2 from '../../assets/images/headphones2.svg';

// pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

// ✅ FIX 1: Icon components moved to module level — stable references, no remounting on parent re-render
const XIcon = () => (
  <svg style={{ width: '100%', height: '100%' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
  </svg>
);

const PlusIcon = () => (
  <svg style={{ width: '24px', height: '24px', color: '#999' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
  </svg>
);

const PngIcon = () => (
  <img src={png_svg} alt="PNG" style={{ width: '20px', height: '20px', }} />
);

const JpgIcon = () => (
  <img src={jpg_svg} alt="JPG" style={{ width: '20px', height: '20px', }} />
);

const FileDocIcon = () => (
  <img src={doc_svg} alt="DOC" style={{ width: '20px', height: '20px', }} />
);

const FileXlsIcon = () => (
  <img src={xls_svg} alt="XLS" style={{ width: '20px', height: '20px', }} />
);

const FileCsvIcon = () => (
  <img src={csv_img} alt="CSV" style={{ width: '20px', height: '20px', }} />
);

const MusicIcon = () => (
  <img src={headphones2} alt="MUSIC" />
);

const FilePdfIcon = () => (
  <img src={pdf_svg} alt="PDF" style={{ width: '20px', height: '20px', }} />
);

const TxtIcon = () => (
  <img src={txt_svg} alt="TXT" style={{ width: '20px', height: '20px', }} />
);

const FileSvgIcon = () => (
  <img src={svg_svg} alt="SVG" style={{ width: '20px', height: '20px', }} />
);

const FileStorageIcon = () => (
  <img src={file_img_storage} alt="File Storage" style={{ width: '20px', height: '20px', }} />
);

const UploadDocument = forwardRef(({
  onFileSelect,
  onTextExtract,
  onUpload,
  assignment_id,
  student_id,
  question_id,
  question_type,
  assignment_type,
  student_answer_json,
  practice_assignment_id,
  onFileOperationChange,
  isFileOperationInProgress,
  onFilesChange,
  handleVoiceText,
  handleVoiceStart,
  handleVoiceLive,
  handleVoiceCancel,
  preloadedFiles,
  setIsTimerPaused,
  setIsRecording,
  setIsVideoBlocked
}, ref) => {
  const [files, setFiles] = useState(preloadedFiles || []);
  const [tempFiles, setTempFiles] = useState([]);

  const [isArrangeModalOpen, setIsArrangeModalOpen] = useState(false);
  const [previewFile, setPreviewFile] = useState(null);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [textContent, setTextContent] = useState('');
  const [draggedIndex, setDraggedIndex] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [isAudioSubmitted, setIsAudioSubmitted] = useState(false);
  const [isRecordingAudio, setIsRecordingAudio] = useState(false);
  const [isAudioActive, setIsAudioActive] = useState(false);
  const [isMicRecording, setIsMicRecording] = useState(false);
  const [isFilesUploaded, setIsFilesUploaded] = useState(false);

  const [isLoadingPreview, setIsLoadingPreview] = useState(false);
  const [currentPreviewIndex, setCurrentPreviewIndex] = useState(0);
  const { token } = useAuth();
  const maxFiles = 5;
  const [isRemovingFile, setIsRemovingFile] = useState(null);
  const globalState = useSelector((state) => state.globalState);
  const [isTempPreviewOpen, setIsTempPreviewOpen] = useState(false);
  const [currentTempPreviewIndex, setCurrentTempPreviewIndex] = useState(0);
  const [arrangedFiles, setArrangedFiles] = useState([]);

  useImperativeHandle(ref, () => ({
    getFilesCount: () => files.length,
    hasFiles: () => files.length > 0
  }));

  // Notify parent whenever upload or removal state changes
  useEffect(() => {
    if (onFileOperationChange) {
      onFileOperationChange(isUploading || isRemovingFile !== null);
    }
  }, [isUploading, isRemovingFile, onFileOperationChange]);

  useEffect(() => {
    if (preloadedFiles) {
      setFiles(preloadedFiles);
    }
  }, [preloadedFiles]);

  //Update audio states when files change (including after loading from localStorage)
  useEffect(() => {
    const hasAudioFile = files.some(file => {
      const isAudio =
        (file.type && file.type.startsWith('audio/')) ||
        /\.(webm|mp3|wav|m4a|ogg)$/i.test(file.name || '');
      return isAudio && file.serverUrl;
    });

    console.log('🔍 Checking for audio file in files:', hasAudioFile);

    if (hasAudioFile) {
      console.log('✅ Audio file found, setting isAudioSubmitted to true');
      setIsAudioSubmitted(true);
      setIsAudioActive(false);
    } else {
      console.log('ℹ️ No audio file found, setting isAudioSubmitted to false');
      setIsAudioSubmitted(false);
      setIsAudioActive(false);
    }
  }, [files]);

  useEffect(() => {
    if (onFilesChange) {
      onFilesChange(files.length > 0);
    }
  }, [files, onFilesChange]);

  const handleMicRecordingStateChange = (isActive) => {
    setIsMicRecording(isActive); // Update the mic recording state
  };

  const handleAudioRecordingStateChange = (isRecording) => {
    setIsRecordingAudio(isRecording);
  };

  const addFileToQueue = (fileOrMetadata) => {
    // Check if it's a File object or file metadata
    const isFileObject = fileOrMetadata instanceof File;

    const newFile = isFileObject ? {
      id: Math.random().toString(36).substr(2, 9),
      file: fileOrMetadata,
      name: fileOrMetadata.name,
      size: fileOrMetadata.size,
      type: fileOrMetadata.type,
      url: URL.createObjectURL(fileOrMetadata),
      isNew: true
    } : fileOrMetadata; // Already formatted as file metadata

    // Add the new file to files state
    setFiles(prevFiles => [...prevFiles, newFile]);
  };

  const saveFilesToLocalStorage = (filesToSave) => {
    try {
      const storageKey = practice_assignment_id
        ? `uploaded_files_${assignment_id}_${practice_assignment_id}_${question_id}_${token}`
        : `uploaded_files_${assignment_id}_${question_id}_${token}`;
      const serializableFiles = filesToSave.map(file => ({
        id: file.id,
        name: file.name,
        size: file.size,
        type: file.type,
        url: file.serverUrl || file.url,
        serverUrl: file.serverUrl
      }));
      localStorage.setItem(storageKey, JSON.stringify(serializableFiles));
      console.log('Files metadata saved to localStorage:', serializableFiles);
    } catch (error) {
      console.error('Error saving files to localStorage:', error);
    }
  };

  const getFileTypeFromName = (filename) => {
    if (!filename || typeof filename !== 'string') {
      return '';
    }

    const extension = filename.split('.').pop().toLowerCase();

    const typeMap = {
      'png': 'image/png',
      'jpg': 'image/jpeg',
      'jpeg': 'image/jpeg',
      'gif': 'image/gif',
      'svg': 'image/svg+xml',
      'pdf': 'application/pdf',
      'doc': 'application/msword',
      'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'txt': 'text/plain',
      'xls': 'application/vnd.ms-excel',
      'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'csv': 'text/csv',
      'mp3': 'audio/mpeg',
      'wav': 'audio/wav',
      'webm': 'audio/webm',
    };

    return typeMap[extension] || '';
  };
  const MAX_FILE_SIZE_BYTES = 5 * 1024 * 1024; // 10 MB per file


  const getFileIcon = (fileType, fileName) => {
    const type = fileType || getFileTypeFromName(fileName);

    // Check if type is a valid string
    if (!type || typeof type !== 'string') {
      return <FileStorageIcon />;
    }

    if (type.includes('png')) return <PngIcon />;
    if (type === 'text/plain') return <TxtIcon />;
    if (type.includes('jpg') || type.includes('jpeg')) return <JpgIcon />;
    if (type.includes('pdf')) return <FilePdfIcon />;
    if (type.includes('xls') || type.includes('xlsx') || type.includes('spreadsheet')) return <FileXlsIcon />;
    if (type.includes('csv')) return <FileCsvIcon />;
    if (type.includes('svg')) return <FileSvgIcon />;
    if (type.includes('word') || type.includes('document')) return <FileDocIcon />;
    if (type.startsWith('audio/')) return <MusicIcon />;
    return <FileStorageIcon />;
  };

  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
  };

  const extractTextFromFile = async (file) => {
    return new Promise((resolve) => {
      const reader = new FileReader();

      if (file.type === 'text/plain') {
        reader.onload = (e) => resolve(e.target.result);
        reader.readAsText(file);
      } else if (file.type === 'application/pdf') {
        resolve(`PDF file uploaded: ${file.name}`);
      } else if (file.type.includes('word') || file.type.includes('document')) {
        resolve(`Document uploaded: ${file.name}`);
      } else if (file.type.startsWith('image/')) {
        const imageUrl = URL.createObjectURL(file);
        resolve(`Image uploaded: ${file.name}`);
      } else {
        resolve(`File uploaded: ${file.name}`);
      }
    });
  };

  const allowedFileExtensions = [
    '.doc', '.docx', '.pdf', '.xls', '.xlsx', '.csv', '.jpg', '.jpeg', '.png', '.svg', '.heic', '.webp'
  ];

  const handleFileChange = async (e) => {
    const selectedFiles = Array.from(e.target.files);
    const remainingSlots = maxFiles - (files.length + tempFiles.length);


    // Validate each file's extension against the allowed extensions
    for (const file of selectedFiles) {
      const fileExtension = file.name.split('.').pop().toLowerCase();

      // If the file extension is not allowed, show error and prevent upload
      if (!allowedFileExtensions.includes(`.${fileExtension}`)) {
        toast.error(`${fileExtension} files cannot be uploaded.`);
        e.target.value = ''; // Reset file input
        return; // Prevent the file upload
      }
    }

    const oversized = selectedFiles.filter(f => f.size > MAX_FILE_SIZE_BYTES);
    if (oversized.length) {
      const names = oversized.map(f => f.name).join(', ');
      toast.error(`These file exceed 5 MB: ${names}`);
      // Keep the smaller files, continue if any remain
    }
    const validBySize = selectedFiles.filter(f => f.size <= MAX_FILE_SIZE_BYTES);

    if (validBySize.length === 0) {
      e.target.value = '';
      return;
    }

    const checkFileCorruption = (file) => {
      return new Promise(async (resolve) => {
        try {
          // --- 1. Image files ---
          if (file.type.startsWith('image/')) {
            const img = new Image();
            const objectUrl = URL.createObjectURL(file);

            img.onload = () => {
              URL.revokeObjectURL(objectUrl);
              resolve(true);
            };

            img.onerror = () => {
              URL.revokeObjectURL(objectUrl);
              resolve(false);
            };

            img.src = objectUrl;
            return;
          }

          // PDF files — magic bytes + encryption + xref check (no pdfjsLib)
          if (file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf')) {
            const reader = new FileReader();
            reader.onload = (e) => {
              try {
                const bytes = new Uint8Array(e.target.result);

                // 1. Check PDF magic bytes: must start with %PDF-
                const isPDF =
                  bytes[0] === 0x25 && // %
                  bytes[1] === 0x50 && // P
                  bytes[2] === 0x44 && // D
                  bytes[3] === 0x46 && // F
                  bytes[4] === 0x2D;   // -

                if (!isPDF) { resolve(false); return; }

                // Decode as latin1 to safely handle binary PDF content
                const text = new TextDecoder('latin1').decode(bytes);

                // 2. Check for password encryption
                const isEncrypted =
                  text.includes('/Encrypt') ||
                  text.includes('/EncryptMetadata') ||
                  text.includes('/StdCF');
                if (isEncrypted) { resolve(false); return; }

                // 3. Check for valid xref table (basic structure integrity)
                const hasXref = text.includes('xref') || text.includes('startxref');
                if (!hasXref) { resolve(false); return; }

                resolve(true);
              } catch (err) {
                resolve(false);
              }
            };
            reader.onerror = () => resolve(false);
            reader.readAsArrayBuffer(file);
            return;
          }

          // --- 3. DOCX / XLSX / PPTX / ZIP files ---
          const ext = file.name.split('.').pop().toLowerCase();
          if (['docx', 'xlsx', 'pptx', 'zip'].includes(ext)) {
            const blobSlice = file.slice(0, 4); // Read the first few bytes
            const buffer = await blobSlice.arrayBuffer();
            const bytes = new Uint8Array(buffer);

            // ZIP files start with "PK" (0x50, 0x4B)
            const isZip = bytes[0] === 0x50 && bytes[1] === 0x4B;
            resolve(isZip);
            return;
          }

          // --- 4. Plain text or others ---
          const reader = new FileReader();
          reader.onload = () => resolve(true);
          reader.onerror = () => resolve(false);
          reader.readAsArrayBuffer(file);

        } catch (err) {
          resolve(false);
        }
      });
    };


    const corruptionResults = await Promise.all(
      validBySize.map(async (file) => ({
        file,
        valid: await checkFileCorruption(file),
      }))
    );

    const corruptedFiles = corruptionResults.filter(r => !r.valid).map(r => r.file);
    const validCorruptionFiles = corruptionResults.filter(r => r.valid).map(r => r.file);

    if (corruptedFiles.length > 0) {
      corruptedFiles.forEach(file => toast.error(`Your attached file ${file.name} is corrupted.`));
    }

    if (validCorruptionFiles.length === 0) {
      e.target.value = '';
      return;
    }


    // Check PDF page count (max 10 pages) — no pdfjsLib
    const pdfValidationResults = await Promise.all(
      validCorruptionFiles.map(async (file) => {
        if (file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf')) {
          try {
            const buffer = await file.arrayBuffer();
            const text = new TextDecoder('latin1').decode(new Uint8Array(buffer));
            // Count /Type /Page entries, excluding /Type /Pages parent node
            const pageMatches = text.match(/\/Type\s*\/Page[^s]/g);
            const pageCount = pageMatches ? pageMatches.length : 1;
            if (pageCount > 10) {
              return { file, valid: false, pageCount };
            }
            return { file, valid: true, pageCount };
          } catch (error) {
            console.error('Error checking PDF pages:', error);
            return { file, valid: true, pageCount: 0 };
          }
        }
        // Non-PDF files pass through
        return { file, valid: true, pageCount: 0 };
      })
    );

    // Filter out invalid PDFs
    const invalidPdfs = pdfValidationResults.filter(result => !result.valid);
    const validFiles = pdfValidationResults.filter(result => result.valid).map(result => result.file);

    // Show error for PDFs exceeding 10 pages
    if (invalidPdfs.length > 0) {
      invalidPdfs.forEach(({ file, pageCount }) => {
        toast.error(`You can upload up to 10 pages only`);
      });
    }
    if (validFiles.length === 0) {
      e.target.value = '';
      return;
    }

    if (validFiles.length > remainingSlots) {
      toast.error(`You can only upload ${remainingSlots} more file(s). Maximum ${maxFiles} files allowed.`);
      return;
    }

    const newFiles = validFiles.map(file => ({
      id: Math.random().toString(36).substr(2, 9),
      file: file,
      name: file.name,
      size: file.size,
      type: file.type,
      url: URL.createObjectURL(file),
      isNew: true // Mark as new file
    }));


    setTempFiles([...tempFiles, ...newFiles]);
    if (!isArrangeModalOpen) {
      // Combine existing files (marked as uploaded) with temp files
      const combined = [
        ...files.map(f => ({ ...f, isNew: false })), // existing files
        ...tempFiles.map(f => ({ ...f, isNew: true })), // previously added temp files
        ...newFiles // newly selected files
      ];

      setArrangedFiles(combined);
      setIsArrangeModalOpen(true);
    } else {
      // Modal already open, just add to arranged files
      setArrangedFiles([...arrangedFiles, ...newFiles]);
    }

    e.target.value = '';
  };

  const handleDragStart = (index) => {
    setDraggedIndex(index);
  };

  const handleDragOver = (e, index) => {
    e.preventDefault();
    if (draggedIndex === null || draggedIndex === index) return;

    const newFiles = [...arrangedFiles];
    const draggedFile = newFiles[draggedIndex];
    newFiles.splice(draggedIndex, 1);
    newFiles.splice(index, 0, draggedFile);

    setArrangedFiles(newFiles);
    setDraggedIndex(index);
  };

  const handleDragEnd = () => {
    setDraggedIndex(null);
  };

  const removeArrangedFile = (id) => {
    const fileToRemove = arrangedFiles.find(f => f.id === id);

    // If it's a new file, revoke the URL
    if (fileToRemove && fileToRemove.url && fileToRemove.isNew) {
      URL.revokeObjectURL(fileToRemove.url);
    }

    // Remove from arranged files
    setArrangedFiles(arrangedFiles.filter(f => f.id !== id));
    // Also remove from tempFiles if it's a new file
    if (fileToRemove && fileToRemove.isNew) {
      setTempFiles(tempFiles.filter(f => f.id !== id));
    }
  };

  const handleCancelArrange = () => {
    // Clean up URLs for new files only
    arrangedFiles.forEach(file => {
      if (file.isNew && file.url) {
        URL.revokeObjectURL(file.url);
      }
    });
    setTempFiles([]);
    setArrangedFiles([]);
    setIsArrangeModalOpen(false);
  };

  // Helper function to fetch file from URL and convert to File object
  const fetchFileFromUrl = async (fileMetadata) => {
    try {
      if (!fileMetadata.serverUrl) {
        console.warn('No server URL for file:', fileMetadata.name);
        return null;
      }

      const response = await fetch(fileMetadata.serverUrl);
      const blob = await response.blob();
      const file = new File([blob], fileMetadata.name, { type: fileMetadata.type });

      return {
        ...fileMetadata,
        file: file
      };
    } catch (error) {
      console.error('Error fetching file from URL:', error);
      return null;
    }
  };

  const handleUploadFiles = async () => {
    setIsUploading(true);
    setIsTimerPaused(false);

    try {
      // Keep the exact order from arrangedFiles
      // Just mark new files with loading state
      const filesInArrangedOrder = arrangedFiles.map(file => {
        if (file.isNew) {
          return { ...file, isLoading: true };
        } else {
          // Find the original file data for existing files
          const original = files.find(existing => existing.id === file.id);
          return original || file;
        }
      });

      // Update UI immediately with the EXACT arranged order
      setFiles(filesInArrangedOrder);

      // Close modal and clear temp states
      setTempFiles([]);
      setArrangedFiles([]);
      setIsArrangeModalOpen(false);

      // Create FormData
      const formData = new FormData();

      // Add all required fields
      formData.append('student_id', student_id);
      formData.append('question_id', question_id);
      formData.append('question_type', question_type);
      formData.append('student_answers_json', JSON.stringify(student_answer_json));
      formData.append('file_type', String('document'));


      if (practice_assignment_id) {
        formData.append('practice_assignment_id', practice_assignment_id);
      } else {
        formData.append('assignment_id', assignment_id);
      }

      // Append files in the exact arranged order
      let appendedCount = 0;
      for (const file of arrangedFiles) {
        if (file.isNew) {
          // New file - append directly
          // Security: separate dynamic data from format string
          console.warn('Appending new file [', appendedCount + 1, ']:', file.name, file.file);
          formData.append('files', file.file);
          appendedCount++;
        } else {
          // Existing file - fetch from server URL first
          const fileObj = await fetchFileFromUrl(file);
          if (fileObj && fileObj.file) {
            // Security: separate dynamic data from format string
            console.warn('Appending existing file [', appendedCount + 1, ']:', fileObj.name, fileObj.file);
            formData.append('files', fileObj.file);
            appendedCount++;
          } else {
            // console.error('Failed to fetch file:', file.name);
          }
        }
      }

      // Log FormData contents for debugging
      // console.log('FormData contents:');
      let fileCount = 0;
      for (let pair of formData.entries()) {
        if (pair[0] === 'files') {
          fileCount++;
        } else {
          // console.log(pair[0], ':', pair[1]);
        }
      }
      // console.log(`Total files in FormData: ${fileCount}`);

      // Verify we have all files before sending
      if (fileCount !== arrangedFiles.length) {
        // console.error(`Mismatch! Expected ${arrangedFiles.length} files but FormData has ${fileCount}`);
      }

      // for (const file of arrangedFiles) {
      // formData.append('files', file.file);
      //   }
      // Call API
      const response = await api.post(
        'submissions/upload-answer/',
        formData,
        {
          headers: {
            'Authorization': `Token ${token}`,
            'Content-Type': 'multipart/form-data',
          },
          timeout: 600000, // 10 minutes timeout for this specific API
        }
      );



      if (response.status === 200 || response.status === 201) {
        console.log('Upload success:', response.data);

        // Parse the response to get file URLs
        const fileUrls = [];
        let fileIndex = 1;
        while (response.data[`file_url${fileIndex}`]) {
          fileUrls.push({
            name: response.data[`file_name${fileIndex}`],
            url: response.data[`file_url${fileIndex}`]
          });
          fileIndex++;
        }

        // Check if we got URLs for all files
        if (fileUrls.length !== arrangedFiles.length) {
          console.error(`Server returned ${fileUrls.length} URLs but we sent ${arrangedFiles.length} files!`);
          toast.warning(`Some files may not have been uploaded correctly. Expected ${arrangedFiles.length} but got ${fileUrls.length} URLs.`);
        }

        // Update files with server URLs in the SAME arranged order
        const updatedFiles = arrangedFiles.map((file, index) => {
          const fileUrl = fileUrls[index];

          if (!fileUrl) {
            // Security: separate dynamic data from format string
            console.error('No URL returned for file at index', index, ':', file.name);
          }

          return {
            id: file.id,
            name: file.name,
            size: file.size,
            type: file.type,
            url: file.url || file.serverUrl,
            serverUrl: fileUrl?.url || file.serverUrl,
            isLoading: false,
            isNew: false // All files are now uploaded
          };
        });

        console.log('Updated files with server URLs:', updatedFiles);
        console.log('Final file count:', updatedFiles.length);

        // Verify all files have serverUrl
        const filesWithoutUrl = updatedFiles.filter(f => !f.serverUrl);
        if (filesWithoutUrl.length > 0) {
          console.error('Files missing server URL:', filesWithoutUrl.map(f => f.name));
        }

        // Update state with final files in arranged order
        setFiles(updatedFiles);

        // Save to localStorage with server URLs
        saveFilesToLocalStorage(updatedFiles);

        // Handle image preview
        const firstNewFile = arrangedFiles.find(f => f.isNew);
        if (onFileSelect && firstNewFile && firstNewFile.type.startsWith('image/')) {
          onFileSelect(firstNewFile.url);
        }

        setIsFilesUploaded(true);

        if (fileUrls.length === arrangedFiles.length) {
          toast.success(`${tempFiles.length} ${tempFiles.length > 1 ? "files" : "file"} uploaded successfully!`);
        } else {
          toast.warning(`Uploaded ${fileUrls.length} out of ${arrangedFiles.length} files.`);
        }

        return response.data;
      }

    } catch (error) {

      const errorMessage = error?.response?.data?.message || error?.response?.data?.error || 'Failed to upload files. Please try again.';
      toast.error(errorMessage);

      // Remove files that failed to upload (those with isLoading: true)
      setFiles(prevFiles => prevFiles.filter(f => !f.isLoading));

    } finally {
      setIsUploading(false);
      setIsTimerPaused(true);
    }
  };

  const removeFile = async (e, id) => {
    e.stopPropagation();
    // Prevent removal if already removing a file
    if (isRemovingFile) {
      toast.warning("Please wait, file removal in progress...");
      return;
    }

    setIsRemovingFile(id);
    setIsTimerPaused(false);

    try {
      const fileToRemove = files.find((f) => f.id === id);
      const updatedFiles = files.filter((f) => f.id !== id);


      const isRemovingAudio =
        (fileToRemove?.type && fileToRemove.type.startsWith('audio/')) ||
        /\.(webm|mp3|wav|m4a|ogg)$/i.test(fileToRemove?.name || '');
      // Create FormData with remaining files
      const formData = new FormData();

      formData.append("student_id", student_id);
      formData.append("question_id", question_id);
      formData.append("question_type", question_type);
      formData.append(
        "student_answers_json",
        JSON.stringify(student_answer_json)
      );
      formData.append('file_type', String('document'));


      if (practice_assignment_id) {
        formData.append("practice_assignment_id", practice_assignment_id);
      } else {
        formData.append("assignment_id", assignment_id);
      }

      // Fetch and append remaining files from server URLs
      if (updatedFiles.length > 0) {
        console.log("Fetching remaining files from server...");
        for (const fileMetadata of updatedFiles) {
          const fileObj = await fetchFileFromUrl(fileMetadata);
          if (fileObj && fileObj.file) {
            console.warn("Appending remaining file:", fileObj.name);
            formData.append("files", fileObj.file);
          }
        }
      } else {
        console.log("Fetching remaining files from server...");
        const fileObj = await fetchFileFromUrl(fileToRemove);
        if (fileObj && fileObj.file) {
          console.warn("Appending remaining file:", fileObj.name);
          formData.append("files", fileObj.file);

        }

        formData.append("delete", true);
      }

      // Log FormData contents
      console.log("FormData contents for removal:");
      let fileCount = 0;
      for (let pair of formData.entries()) {
        if (pair[0] === "files") {
          fileCount++;
        }
      }

      const response = await api.post("submissions/upload-answer/", formData, {
        headers: {
          Authorization: `Token ${token}`,
        },
        timeout: 600000, // 10 minutes timeout for this specific API
      });

      console.log("File removal response:", response.data);

      if (response.status === 200 || response.status === 201) {
        console.log("File removal success:", response.data);

        // Parse the response to get updated file URLs
        const fileUrls = [];
        let fileIndex = 1;
        while (response.data[`file_url${fileIndex}`]) {
          fileUrls.push({
            name: response.data[`file_name${fileIndex}`],
            url: response.data[`file_url${fileIndex}`],
          });
          fileIndex++;
        }

        const finalUpdatedFiles = updatedFiles.map((file, index) => ({
          ...file,
          serverUrl: fileUrls[index]?.url || file.serverUrl,
        }));

        // UPDATE STATE
        setFiles(finalUpdatedFiles);

        // Update localStorage
        saveFilesToLocalStorage(finalUpdatedFiles);
        // Revoke blob URL only if it's not a server URL
        if (fileToRemove && fileToRemove.url && !fileToRemove.serverUrl) {
          URL.revokeObjectURL(fileToRemove.url);
        }
        if (isRemovingAudio) {
          setIsAudioSubmitted(false);
          setIsAudioActive(false);
        }

        toast.success(`File removed successfully!`);
      }
    } catch (error) {
      console.error("File removal error:", error);

      const fileToRemove = files.find((f) => f.id === id);
      const updatedFiles = files.filter((f) => f.id !== id);

      const isRemovingAudio =
        (fileToRemove?.type && fileToRemove.type.startsWith('audio/')) ||
        /\.(webm|mp3|wav|m4a|ogg)$/i.test(fileToRemove?.name || '');

      // Check if it's a 400 error or any error - remove file from UI anyway
      if (error?.response?.status === 400 || error?.response?.status) {
        // Update state - remove the file
        setFiles(updatedFiles);

        // Update localStorage
        saveFilesToLocalStorage(updatedFiles);

        // Revoke blob URL only if it's not a server URL
        if (fileToRemove && fileToRemove.url && !fileToRemove.serverUrl) {
          URL.revokeObjectURL(fileToRemove.url);
        }
        if (isRemovingAudio) {
          setIsAudioSubmitted(false);
          setIsAudioActive(false);
        }
        toast.success(`File removed successfully!`);
        // Show appropriate message
        if (error?.response?.status === 400) {
          toast.success(`File removed successfully!`);
        } else {
          toast.warning(`File removed locally. Server update may have failed.`);
        }
      } else {
        // For network errors or other issues
        const errorMessage =
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          "Failed to remove file. Please try again.";
        toast.error(errorMessage);
      }
    } finally {
      setIsRemovingFile(null);
      setIsTimerPaused(true);
    }
  };

  const openPreview = async (file, index = 0) => {
    setCurrentPreviewIndex(index);
    setIsPreviewOpen(true);
  };

  const closePreview = () => {
    setIsPreviewOpen(false);
  };

  const getFileTypeLabel = (type) => {
    if (type === 'image/svg+xml' || type.includes('svg')) return 'SVG';
    if (type.startsWith('image/')) return type.split('/')[1].toUpperCase();
    if (type === 'application/pdf') return 'PDF';
    if (type === 'text/plain') return 'TXT';
    if (type.includes('word')) return 'WORD';
    if (type.includes('document')) return 'DOC';
    if (type.startsWith('audio/')) return 'AUDIO';
    return 'FILE';
  };

  const openArrangedPreview = (index) => {
    setCurrentTempPreviewIndex(index);
    setIsTempPreviewOpen(true);
  };

  const closeTempPreview = () => {
    setIsTempPreviewOpen(false);
  };

  const handleAudioStateChange = (isActive) => {
    setIsAudioActive(isActive);
  };

  const handleAudioUploaded = (uploadedFileData) => {
    if (!uploadedFileData) {
      // Upload failed, remove the loading file
      setFiles(prevFiles => prevFiles.filter(f => !f.isLoading));
      setIsRecordingAudio(false);
      setIsAudioActive(false);
      setIsAudioSubmitted(false);
      return;
    }

    const isAudio =
      (uploadedFileData.type && uploadedFileData.type.startsWith('audio/')) ||
      /\.(webm|mp3|wav|m4a|ogg)$/i.test(uploadedFileData.name || '');

    if (isAudio) {
      setIsAudioSubmitted(true);
      setIsAudioActive(true);
      setIsRecordingAudio(false);
    }

    setFiles(prevFiles => {
      const updatedFiles = prevFiles.map(f =>
        f.id === uploadedFileData.id
          ? { ...uploadedFileData, isLoading: false, isNew: false }
          : f
      );

      // Save to localStorage with the updated files
      saveFilesToLocalStorage(updatedFiles);
      return updatedFiles;
    });
  };

  const hasNonAudioFiles = () => {
    return files.some(file => {
      const isAudio =
        (file.type && file.type.startsWith('audio/')) ||
        /\.(webm|mp3|wav|m4a|ogg)$/i.test(file.name || '');
      return !isAudio;
    });
  };

  // Add a helper function to find existing audio file
  const getExistingAudio = () => {
    return files.find(file => {
      const isAudio =
        (file.type && file.type.startsWith('audio/')) ||
        /\.(webm|mp3|wav|m4a|ogg)$/i.test(file.name || '');
      return isAudio && file.serverUrl; // Only consider uploaded audio
    });
  };

  const isTeacher = globalState.role === "Teacher";
  return (
    <div className='submission-buttons'>
      <div className='submissions-buttons-flex' >
        <VoiceMicButton
          onTextExtracted={handleVoiceText}
          onVoiceStart={handleVoiceStart}
          onLiveTranscript={handleVoiceLive}
          onVoiceCancel={handleVoiceCancel}
          disabled={isFileOperationInProgress || isAudioActive || isMicRecording || isRecordingAudio}
          onMicButtonStateChange={handleMicRecordingStateChange}
          setIsRecordingTwo={setIsRecording}
          setIsTimerPaused={setIsTimerPaused}
          isTeacher={isTeacher}
          setIsVideoBlocked={setIsVideoBlocked}
        />

        <VoiceAudioRecorder
          assignment_id={assignment_id}
          student_id={student_id}
          question_id={question_id}
          question_type={question_type}
          assignment_type={assignment_type}
          student_answer_json={student_answer_json}
          practice_assignment_id={practice_assignment_id}
          onAudioSave={addFileToQueue}
          onAudioUploaded={handleAudioUploaded}
          disabled={isFileOperationInProgress || isAudioSubmitted || hasNonAudioFiles() || isMicRecording}
          onRecordingStateChange={handleAudioRecordingStateChange}
          onAudioStateChange={handleAudioStateChange}
          existingAudio={getExistingAudio()}
          setIsTimerPaused={setIsTimerPaused}
          onFileOperationChange={onFileOperationChange}
          isFileOperationInProgress={isFileOperationInProgress}
          isTeacher={isTeacher}
          setIsVideoBlocked={setIsVideoBlocked}
        />
        <div className={`UplodeFile-folder ${files.length >= maxFiles ? 'max-files-reached' : ''}`} style={{ cursor: isTeacher || isFileOperationInProgress || isAudioActive || isMicRecording || isRecordingAudio ? "not-allowed" : "pointer" }}>
          <input
            id="multiFileInput"
            type="file"
            multiple
            onChange={handleFileChange}
            disabled={isFileOperationInProgress || isTeacher || files.length >= maxFiles || isAudioSubmitted || isAudioActive || isMicRecording || isRecordingAudio}
            accept="*/*"
            style={{ display: "none" }}
          />
          <label htmlFor="multiFileInput" data-tooltip-id="upload-files-tooltip" style={{ cursor: isFileOperationInProgress || isAudioSubmitted || isAudioActive || isMicRecording || isRecordingAudio ? "not-allowed" : "pointer" }}>
            <i className="fa-solid fa-upload" style={{ color: isTeacher || isFileOperationInProgress || isAudioSubmitted || isAudioActive || isMicRecording || isRecordingAudio ? "#B3B3B3" : "#0068FF" }}></i>
          </label>

        </div>
        <Tooltip
          id="upload-files-tooltip"
          place="top"
          content={files.length === 0 ? "Upload Files" : "You can upload up to 5 files"}
          type="light"
          effect="float"
          style={{ display: isTeacher || isFileOperationInProgress || isAudioSubmitted || isRecordingAudio || isMicRecording || isRecordingAudio || isAudioActive ? "none" : "block" }}
        />

      </div>
      {files.length > 0 && (
        <>
          <div className='uploaded-files-list' style={{ fontSize: '12px', color: '#000', fontWeight: '600' }}>
            FILES
          </div>
          <div className='uploaded-files-container'>

            {files.map((file, index) => (
              <div className='uploaded-file-item'
                key={file.id}
                // onClick={() => openPreview(file)}
                onClick={() => !isRemovingFile && !file.isLoading && openPreview(file, index)}
                style={{
                  opacity: (isRemovingFile === file.id || file.isLoading) ? 0.6 : 1,
                  pointerEvents: (isRemovingFile === file.id || file.isLoading) ? 'none' : 'auto',
                  position: 'relative'
                }}
                title={file.name}
              >
                <div className='uploaded-file-icon' style={{ borderRadius: "50%" }}>{getFileIcon(file.type, file.name)}</div>
                <div className='uploaded-file-info'>
                  <span style={{
                    fontSize: '12px',
                    color: '#000',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: '90px',
                    fontWeight: '400'
                  }}>
                    {file.name}

                  </span>
                  <div style={{ fontSize: '10px', color: '#666', display: 'inline-block' }}>
                    {formatFileSize(file.size)}
                  </div>
                </div>

                {(isRemovingFile === file.id || file.isLoading) ? (
                  <div style={{
                    marginLeft: 'auto',
                    flexShrink: 0,
                    width: '21px',
                    height: '21px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>

                    <div style={{
                      width: '16px',
                      height: '16px',
                      border: '2px solid #f3f3f3',
                      borderTop: '2px solid #0068FF',
                      borderRadius: '50%',
                      animation: 'spin 1s linear infinite'
                    }}></div>
                  </div>
                ) : (
                  <button
                    onClick={(e) => removeFile(e, file.id)}
                    disabled={isRemovingFile !== null || file.isLoading || isUploading}
                    style={{
                      background: 'none',
                      border: 'none',
                      padding: '2px',
                      cursor: (isRemovingFile !== null || file.isLoading || isUploading) ? 'not-allowed' : 'pointer',
                      color: '#000',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      borderRadius: '3px',
                      marginLeft: 'auto',
                      flexShrink: 0,
                      width: '21px',
                      height: '21px',
                      opacity: (isRemovingFile !== null || file.isLoading || isUploading) ? 0.5 : 1
                    }}
                    aria-label="Remove file"
                  >
                    <XIcon />
                  </button>
                )}
              </div>
            ))}
          </div>
        </>
      )}

      {/* Arrange Files Modal */}
      {isArrangeModalOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
            padding: '20px'
          }}
        >
          <div
            style={{
              background: 'white',
              borderRadius: '12px',
              maxWidth: '750px',
              width: '100%',
              maxHeight: '85vh',
              overflow: 'hidden',
              display: 'flex',
              flexDirection: 'column',
              boxShadow: '0 10px 40px rgba(0, 0, 0, 0.2)'
            }}
          >
            {/* Header */}
            <div style={{ padding: '24px 24px 16px', borderBottom: '1px solid #e5e7eb' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
                <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '600', color: '#111827' }}>
                  Upload Your Notes
                </h2>
                <button
                  onClick={handleCancelArrange}
                  style={{
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    padding: '4px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '4px',
                    width: '28px',
                    height: '28px'


                  }}
                  onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f3f4f6'}
                  onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                >
                  <div>
                    <img src={cancel} alt="cancel" />
                  </div>
                </button>
              </div>
              <p style={{ margin: 0, fontSize: '13px', color: '#6b7280', lineHeight: '1.5' }}>
                Add your handwritten or digital notes. Drag to arrange multiple files.
              </p>
            </div>

            {/* Files Grid */}
            <div style={{ flex: 1, overflow: 'auto', padding: '24px' }}>
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(5, 1fr)',
                gap: '16px',
              }}>
                {arrangedFiles.map((file, index) => (
                  <div key={file.id}>
                    <div
                      draggable
                      onDragStart={() => handleDragStart(index)}
                      onDragOver={(e) => handleDragOver(e, index)}
                      onDragEnd={handleDragEnd}
                      onClick={() => openArrangedPreview(index)}
                      style={{
                        position: 'relative',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        padding: '12px',
                        backgroundColor: draggedIndex === index ? '#f3f4f6' : (file.isNew ? '#f9fafb' : '#e8f4ff'),
                        border: `1px solid ${file.isNew ? '#e5e7eb' : '#b3d9ff'}`,
                        borderRadius: '8px',
                        cursor: 'move',
                        transition: 'all 0.2s'
                      }}
                    >
                      {/* Badge for uploaded files */}
                      {!file.isNew && (
                        <div style={{
                          position: 'absolute',
                          top: '6px',
                          left: '6px',
                          background: '#0068FF',
                          color: 'white',
                          fontSize: '9px',
                          padding: '2px 6px',
                          borderRadius: '4px',
                          fontWeight: '600',
                          zIndex: 2
                        }}>
                          ✓
                        </div>
                      )}
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          removeArrangedFile(file.id);
                        }}
                        style={{
                          position: 'absolute',
                          top: '6px',
                          right: '6px',
                          background: 'white',
                          border: '1px solid #e5e7eb',
                          borderRadius: '50%',
                          width: '24px',
                          height: '24px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          cursor: 'pointer',
                          boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                          zIndex: 2
                        }}
                      >
                        <div style={{ width: '14px', color: '#000' }}>
                          <XIcon />
                        </div>
                      </button>

                      {file.type.startsWith('image/') ? (
                        <img
                          src={file.url || file.serverUrl}
                          alt={file.name}
                          style={{
                            width: '100%',
                            height: '100px',
                            objectFit: 'cover',
                            borderRadius: '4px',
                            marginBottom: '8px',
                            backgroundColor: '#e5e7eb'
                          }}
                        />
                      ) : (
                        <div style={{
                          width: '100%',
                          height: '100px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backgroundColor: '#e5e7eb',
                          borderRadius: '4px',
                          marginBottom: '8px'
                        }}>
                          <div style={{ textAlign: 'center' }}>
                            {getFileIcon(file.type, file.name)}
                            <div style={{
                              fontSize: '11px',
                              fontWeight: '600',
                              color: '#6b7280',
                              marginTop: '8px'
                            }}>
                              {getFileTypeLabel(file.type)}
                            </div>
                          </div>
                        </div>
                      )}
                      <div style={{
                        fontSize: '11px',
                        color: '#555555',
                        textAlign: 'center',
                        marginBottom: '4px',
                        maxWidth: "100px",
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                      }}>
                        {file.name}
                      </div>
                      <div style={{ fontSize: '10px', color: '#9ca3af' }}>
                        {formatFileSize(file.size)}
                      </div>

                    </div>
                    <div style={{
                      fontSize: '18px',
                      fontWeight: "800",
                      color: 'rgb(200 200 200)',
                      textAlign: 'center',
                      marginTop: "8px"
                    }}>
                      {index + 1}
                    </div>
                  </div>
                ))}

                {/* Add More Button */}
                {arrangedFiles.length < maxFiles && (
                  <div>
                    <label
                      htmlFor="addMoreFiles"
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '12px',
                        backgroundColor: '#f9fafb',
                        border: '2px dashed #d1d5db',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        minHeight: '168px',
                        transition: 'all 0.2s'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#f3f4f6';
                        e.currentTarget.style.borderColor = '#9ca3af';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = '#f9fafb';
                        e.currentTarget.style.borderColor = '#d1d5db';
                      }}
                    >
                      <input
                        id="addMoreFiles"
                        type="file"
                        multiple
                        onChange={handleFileChange}
                        style={{ display: 'none' }}
                        accept="*/*"
                      />
                      <PlusIcon />
                      <div style={{
                        fontSize: '12px',
                        color: '#6b7280',
                        marginTop: '8px',
                        fontWeight: '500',
                        textAlign: 'center'
                      }}>
                        Add DOCX, PDF,<br />JPEG, PNG
                      </div>
                      <div style={{ fontSize: '10px', color: '#9ca3af', marginTop: '4px' }}>
                        MAX FILE SIZE<br />5 MB
                      </div>
                    </label>
                  </div>

                )}
              </div>
            </div>

            {/* Footer Buttons */}
            <div style={{
              padding: '16px 24px',
              display: 'flex',
              gap: '12px',
              justifyContent: 'flex-end'
            }}>
              <button
                onClick={handleCancelArrange}
                disabled={isUploading}
                style={{
                  padding: '10px 32px',
                  borderRadius: '6px',
                  border: '1px solid #0068FF',
                  backgroundColor: 'white',
                  color: '#0068FF',
                  fontSize: '14px',
                  fontWeight: '500',
                  cursor: isUploading ? 'not-allowed' : 'pointer',
                  opacity: isUploading ? 0.6 : 1,
                  transition: 'all 0.2s'
                }}
                onMouseEnter={(e) => !isUploading && (e.currentTarget.style.backgroundColor = '#eff6ff')}
                onMouseLeave={(e) => !isUploading && (e.currentTarget.style.backgroundColor = 'white')}
              >
                Cancel
              </button>
              <button
                onClick={handleUploadFiles}
                disabled={arrangedFiles.length === 0 || isUploading}
                style={{
                  padding: '10px 32px',
                  borderRadius: '6px',
                  border: 'none',
                  backgroundColor: arrangedFiles.length === 0 || isUploading ? '#93c5fd' : '#0068FF',
                  color: 'white',
                  fontSize: '14px',
                  fontWeight: '500',
                  cursor: arrangedFiles.length === 0 || isUploading ? 'not-allowed' : 'pointer',
                  transition: 'all 0.2s'
                }}
                onMouseEnter={(e) => {
                  if (arrangedFiles.length > 0 && !isUploading) {
                    e.currentTarget.style.backgroundColor = '#0056d2';
                  }
                }}
                onMouseLeave={(e) => {
                  if (arrangedFiles.length > 0 && !isUploading) {
                    e.currentTarget.style.backgroundColor = '#0068FF';
                  }
                }}
              >
                {isUploading ? 'Uploading...' : 'Upload'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Preview Modal */}
      <FilePreviewModal
        isOpen={isPreviewOpen}
        files={files}
        initialIndex={currentPreviewIndex}
        onClose={closePreview}
        getFileIcon={getFileIcon}
      />

      {/* Temp File Preview Modal */}
      <FilePreviewModal
        isOpen={isTempPreviewOpen}
        files={arrangedFiles}
        initialIndex={currentTempPreviewIndex}
        onClose={closeTempPreview}
        getFileIcon={getFileIcon}
      />
    </div>
  );
});

export default UploadDocument;